/* 360DT site-wide interaction layer, 5 Oct 2026 (theme 77.0). Loaded with defer from layout/theme.liquid;
   styles live in the dt-ux <style> block there. Every part is independent and fails silently.
   1. Skip to content  - lands after the header (the header is a section INSIDE #MainContent).
   2. Reading progress - thin bar on blog articles (the guides).
   3. Copy buttons     - on every <pre> code block in page and article content.
   4. Form messages    - status/error lines become polite live regions so screen readers announce them.
   5. Cart remove      - asks before removing a course from the cart. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('dt-ux:', e); } }

  /* ---------- 1. skip to content ---------- */
  safe(function () {
    var link = document.querySelector('.skip-to-content-link');
    var main = document.getElementById('MainContent');
    if (!link || !main) return;
    link.addEventListener('click', function (e) {
      var header = main.querySelector(':scope > .dt-header-section');
      var target = (header && header.nextElementSibling) || main;
      e.preventDefault();
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      var top = target.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0);
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---------- 2. reading progress (articles only) ---------- */
  safe(function () {
    var body = document.querySelector('.article-template__content');
    if (!body) return;
    var bar = document.createElement('div');
    bar.className = 'dt-progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span></span>';
    document.body.appendChild(bar);
    var fill = bar.firstChild, ticking = false;
    function update() {
      ticking = false;
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      bar.classList.toggle('is-on', p > 0.005);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- 3. copy buttons on code blocks ---------- */
  safe(function () {
    var copyIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';
    each('#MainContent pre', function (pre) {
      if (pre.closest('.dtx-code') || pre.offsetHeight < 20) return;
      var wrap = document.createElement('div');
      wrap.className = 'dtx-code';
      pre.parentNode.insertBefore(wrap, pre);
      wrap.appendChild(pre);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dtx-code__copy';
      btn.setAttribute('aria-label', 'Copy code to clipboard');
      btn.innerHTML = copyIcon + '<span>Copy</span>';
      var label = btn.lastChild;
      var timer;
      function done(ok) {
        label.textContent = ok ? 'Copied' : 'Press Ctrl+C';
        btn.classList.toggle('is-done', ok);
        clearTimeout(timer);
        timer = setTimeout(function () { label.textContent = 'Copy'; btn.classList.remove('is-done'); }, 2000);
      }
      btn.addEventListener('click', function () {
        var text = pre.innerText.replace(/ /g, ' ').replace(/\n$/, '');
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text).then(function () { done(true); }, fallback);
        } else { fallback(); }
        function fallback() {
          var sel = window.getSelection(), range = document.createRange();
          range.selectNodeContents(pre); sel.removeAllRanges(); sel.addRange(range);
          var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
          if (ok) sel.removeAllRanges();
          done(ok);
        }
      });
      wrap.appendChild(btn);
    });
  });

  /* ---------- 4. form status lines announced to screen readers ---------- */
  safe(function () {
    each('.msg, [class*="__msg"], [class*="-msg"], [id*="status"], [id$="-m1"], [id$="-m2"], .form__message, .form-status', function (el) {
      if (el.hasAttribute('aria-live') || el.querySelector('input,select,textarea,button,a')) return;
      if ((el.textContent || '').length > 400) return;
      var near = el.parentElement, isForm = false;
      for (var i = 0; i < 3 && near && !isForm; i++, near = near.parentElement) isForm = !!near.querySelector('input:not([type=hidden]),select,textarea');
      if (!isForm) return;
      el.setAttribute('aria-live', 'polite');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'status');
    });
  });

  /* ---------- 5. confirm before removing a course from the cart ---------- */
  safe(function () {
    if (!document.querySelector('cart-remove-button')) return;
    var dlg = document.createElement('div');
    dlg.className = 'dt-confirm';
    dlg.hidden = true;
    dlg.innerHTML =
      '<div class="dt-confirm__scrim" data-dt-cancel></div>' +
      '<div class="dt-confirm__box" role="alertdialog" aria-modal="true" aria-labelledby="dtConfirmTitle" aria-describedby="dtConfirmText">' +
        '<p class="dt-confirm__title" id="dtConfirmTitle">Remove this course?</p>' +
        '<p class="dt-confirm__text" id="dtConfirmText"></p>' +
        '<div class="dt-confirm__actions">' +
          '<button type="button" class="dt-confirm__keep" data-dt-cancel>Keep it</button>' +
          '<button type="button" class="dt-confirm__remove">Remove</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);
    var text = dlg.querySelector('.dt-confirm__text');
    var keep = dlg.querySelector('.dt-confirm__keep');
    var go = dlg.querySelector('.dt-confirm__remove');
    var pending = null, opener = null;
    function close() { dlg.hidden = true; document.documentElement.classList.remove('dt-confirm-open'); if (opener) opener.focus(); pending = null; }
    document.addEventListener('click', function (e) {
      var host = e.target.closest && e.target.closest('cart-remove-button');
      if (!host || host.__dtConfirmed) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var a = host.querySelector('a,button');
      var name = (a && a.getAttribute('aria-label') || '').replace(/^Remove\s*/i, '');
      text.textContent = name ? name + ' will be taken out of your cart. You can add it again any time.' : 'It will be taken out of your cart. You can add it again any time.';
      pending = host; opener = a || host;
      dlg.hidden = false;
      document.documentElement.classList.add('dt-confirm-open');
      keep.focus();
    }, true);
    go.addEventListener('click', function () {
      var host = pending; close();
      if (!host) return;
      host.__dtConfirmed = true;
      var a = host.querySelector('a,button') || host;
      a.click();
      setTimeout(function () { host.__dtConfirmed = false; }, 1500);
    });
    each('[data-dt-cancel]', function (el) { el.addEventListener('click', close); }, dlg);
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === keep) { e.preventDefault(); go.focus(); }
        else if (!e.shiftKey && document.activeElement === go) { e.preventDefault(); keep.focus(); }
      }
    });
  });
})();
